import { ColorfulProgress, Center } from '@maas-components/core'

const Loading = () => {
  return (
    <Center viewport>
      <span data-testid="progress">
        <ColorfulProgress size={60} />
      </span>
    </Center>
  )
}

export default Loading
